import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemType2dIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20 1.25H4C2.48 1.25 1.25 2.48 1.25 4V20C1.25 21.52 2.48 22.75 4 22.75H20C21.52 22.75 22.75 21.52 22.75 20V4C22.75 2.48 21.52 1.25 20 1.25ZM21.25 20C21.25 20.69 20.69 21.25 20 21.25H4C3.31 21.25 2.75 20.69 2.75 20V4C2.75 3.31 3.31 2.75 4 2.75H20C20.69 2.75 21.25 3.31 21.25 4V20Z"
        fill={color}
      />
      <path
        d="M8.91996 13.21C9.91996 12.42 10.78 11.69 10.78 10.49C10.78 9.29001 9.90996 8.39001 8.39996 8.39001C6.88996 8.39001 6.13996 9.20001 5.82996 10.17L7.13996 10.67C7.27996 10.14 7.59996 9.69001 8.25996 9.69001C8.70996 9.69001 9.17996 10.03 9.17996 10.56C9.17996 11.15 8.90996 11.61 8.12996 12.28L5.97996 14.12V15.49H10.92V14.23H7.61996L8.91996 13.21Z"
        fill={color}
      />
      <path
        d="M15 8.51001H12.37V15.49H15C16.85 15.49 18.07 14.32 18.07 12C18.07 9.68001 16.85 8.51001 15 8.51001ZM16.46 12.54C16.46 13.65 15.9 14.14 15 14.14H13.89V9.86001H15C15.9 9.86001 16.46 10.35 16.46 11.46V12.54Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemType2dIcon.displayName = 'ItemType2dIcon';
